import React from "react";
import styled, { css } from "styled-components";
import { Box } from "../Box";
import { Text } from "../Text";
const DismissIcon = styled.div(({ theme: { colors: { searchBoxColors }, }, active, }) => css `
    font-family: "Glyphicons Halflings";
    font-size: 9px;
    color: ${active === true ? searchBoxColors.dismissActive : searchBoxColors.dismiss};
    line-height: 1;
    margin-top: 4px;
    margin-left: 3px;

    &::before {
      content: "\\e014"; /* X icon */
    }

    &:hover {
      cursor: pointer;
    }
  `);
const StyledBox = styled(Box)(({ theme: { colors: { searchBoxColors }, borders, fontSizes, }, }) => ({
    "&.active": {
        background: searchBoxColors.filterActiveBackground,
        color: searchBoxColors.filterActiveText,
    },
    "&.disabled": {
        backgroundColor: searchBoxColors.filterDisabledBackground,
        borderColor: searchBoxColors.filterDisabledBorder,
        color: searchBoxColors.filterDisabledText,
        padding: "3px 5px 3px 3px",
        pointerEvents: "none",
    },
    alignItems: "flex-start",
    background: `${searchBoxColors.filterBackground}`,
    border: borders[1],
    borderColor: searchBoxColors.filterBorder,
    borderRadius: "3px",
    color: searchBoxColors.filterText,
    display: "inline-flex",
    fontSize: fontSizes[0],
    lineHeight: "15px",
    margin: "3px 5px 2px 0",
    padding: "3px 5px 3px",
}));
export const SearchBoxFilter = ({ active = false, disabled, filter, filterIndex, removeFilterAt, }) => {
    var _a;
    const classActive = active && !disabled ? "active" : "";
    const classDisabled = disabled ? "disabled" : "";
    return (React.createElement(StyledBox, { "data-testid": "searchBoxFilter", className: `searchBoxFilter ${classDisabled} ${classActive}` },
        React.createElement("div", null,
            filter.facet && React.createElement(Text, { fontSize: 0, style: { color: "inherit" } }, `${filter.facet.name}: `), (_a = filter.modifiers) === null || _a === void 0 ? void 0 :
            _a.map((modifier) => (React.createElement(Text, { fontSize: 0, key: modifier.id, style: { color: "inherit" } }, `${modifier.name}: `))),
            React.createElement(Text, { fontSize: 0, fontWeight: 600, style: { color: "inherit", overflowWrap: "anywhere" } }, filter.entityName || "\u2026")),
        !disabled && (React.createElement(DismissIcon, { "data-testid": "searchBoxFilterIcon", active: active, onClick: () => removeFilterAt === null || removeFilterAt === void 0 ? void 0 : removeFilterAt(filterIndex) }))));
};
